import React from 'react'
import './PlansScreen.css'

function PlansScreen() {
  return (
    <div className='planscreen'>

<div className='planscreen_plan'>

<diV className="planscreen_info">
<h5>Premium</h5>
<h6>4k + HDR</h6>

</diV>
<button>Subscribe</button>
</div>
<div className='planscreen_plan'>

<diV className="planscreen_info">
<h5>Basic</h5>
<h6>720p</h6>

</diV>
<button>Subscribe</button>
</div>
<div className='planscreen_plan'>

<diV className="planscreen_info">
<h5>Standard</h5>
<h6>1080p</h6>

</diV>
<button>Subscribe</button>
</div>
    </div>
  )
}

export default PlansScreen